import {useEffect, type RefObject} from 'react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {clearUnifiedBatchFromStorage, saveUnifiedBatchToStorage} from '../helpers/unified-batch-storage'
import type {LayoutStoreInstance} from './LayoutStore'

/**
 * Persists unified-batch mutations to sessionStorage. The subscription is installed
 * exactly once per provider instance and is a no-op when the flag is off (no slice
 * mutations will fire because UI consumers are gated on the same flag).
 */
export function usePersistUnifiedBatch(
  storeRef: RefObject<LayoutStoreInstance | null>,
  pathName: string,
  headSha: string,
): void {
  useEffect(() => {
    const store = storeRef.current
    if (!store) return
    if (!isFeatureEnabled('unified_batch_pr_comments')) return
    const unsubscribe = store.subscribe((state, prevState) => {
      const items = state.unifiedBatch.items
      if (items === prevState.unifiedBatch.items) return
      if (items.length === 0) {
        clearUnifiedBatchFromStorage(pathName, headSha)
      } else {
        saveUnifiedBatchToStorage(pathName, headSha, items)
      }
    })
    return unsubscribe
  }, [storeRef, pathName, headSha])
}
